    function cleanModelName(model) {

        return model.replace("PowerEdge", "")
                        .replace("Supermicro", "")
                        .replace("xd", "")
                        .replace("Dell Certified", "")
                        .replace("Dell", "")
                        .replace("Dell Certified Refurbished", "")
                        .replace("Certified Refurbished", "")
                        .replace("Refurbished", "")
                        .replace("chassis_", "")
                        .trim(); 
                    
    }
    
    function showAnswer(id) {
        const answerElement = document.getElementById(id);
        const svgElement = document.getElementById(id.replace('answer', 'svg'));
        if (answerElement) {
            answerElement.classList.toggle('hide');
            if (svgElement) {
                svgElement.classList.toggle('svg-rotate');
            }
        }
    }
    
    let hasReviews = false;
    let hasFaqs = false;
    
    function showTab(tabName) {
        document.querySelectorAll('.tab-content').forEach(content => {
            content.classList.remove('active');
        });
        
        document.querySelectorAll('.tab').forEach(tab => {
            tab.classList.remove('active');
        });
        
        document.getElementById(tabName + '-content').classList.add('active');
        event.target.classList.add('active');
    }
    
    function checkAndManageVisibility() {
        const faqTab = document.querySelector('.tab[onclick="showTab(\'faq\')"]');
        const reviewsTab = document.getElementById('reviews-tab');
        const tabContainer = document.querySelector('.tab-container');
        
        if (!hasFaqs && faqTab) {
            faqTab.style.display = 'none';
        }
        
        if (hasReviews && reviewsTab) {
            reviewsTab.style.display = 'block';
        }
        
        if (!hasFaqs && !hasReviews) {
            return;
        }
        
        document.querySelector('.product-faqs').classList.add('show');
        
        if ((hasFaqs && !hasReviews) || (!hasFaqs && hasReviews)) {
            const titleContainer = document.querySelector('.section-title-container');
            const titleElement = document.getElementById('single-section-title');
            const tabContainer = document.querySelector('.tab-container');
            
            tabContainer.style.display = 'none';
            titleContainer.style.display = 'block';
            
            if (hasFaqs) {
                document.getElementById('faq-content').classList.add('active');
                document.getElementById('reviews-content').classList.remove('active');
                titleElement.textContent = 'Frequently Asked Questions';
            } else {
                document.getElementById('reviews-content').classList.add('active');
                document.getElementById('faq-content').classList.remove('active');
                titleElement.textContent = 'Customer Reviews';
            }
        } else {
            document.querySelector('.section-title-container').style.display = 'none';
            document.querySelector('.tab-container').style.display = 'flex';
        }
    }
    
    async function getReviews(sku) {
        try {
            const response = await fetch(`https://apiapi.ombligo.com/reviews/get?sku=${encodeURIComponent(sku)}`);
            const data = await response.json();
            
            if (data && data.status === 'success' && data.reviews && data.reviews.length > 0) {
                hasReviews = true;
                displayReviews(data.reviews);
            }
        } catch (error) {
            console.error('Error fetching reviews:', error);
        }
    }
    
    function displayReviews(reviews) {
        const reviewsList = document.getElementById('reviews-list');
        
        if (reviews.length === 0) {
            reviewsList.innerHTML = '<div class="no-reviews">No reviews available for this product.</div>';
            return;
        }
        
        const limitedReviews = reviews.slice(0, 3);
        
        reviewsList.innerHTML = limitedReviews.map(review => {
            const stars = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
            const reviewDate = new Date(review.created_at).toLocaleDateString();
            
            return `
                <div class="review-card">
                    <div class="review-header">
                        <span class="reviewer-name">${review.reviewer_name}</span>
                        <span class="review-date">${reviewDate}</span>
                    </div>
                    <div class="review-rating">
                        <span class="stars">${stars}</span>
                    </div>
                    <div class="review-body">${review.review_body}</div>
                    <div class="review-source">Purchased: <b>${review.sku}</b></div>
                    <div class="review-source">Source: ${review.source}</div>
                </div>
            `;
        }).join('');

        if (reviews.length > 3) {
            let showAllButton = document.createElement('button');
            showAllButton.textContent = "Show All Reviews";
            showAllButton.style = "display: block; margin: 20px auto; padding: 10px 20px; background-color: #00243f; color: white; border: none; border-radius: 4px; cursor: pointer;";
            showAllButton.onclick = () => {
                reviewsList.innerHTML = reviews.map(review => {
                    const stars = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
                    const reviewDate = new Date(review.created_at).toLocaleDateString();
                    
                    return `
                        <div class="review-card">
                            <div class="review-header">
                                <span class="reviewer-name">${review.reviewer_name}</span>
                                <span class="review-date">${reviewDate}</span>
                            </div>
                            <div class="review-rating">
                                <span class="stars">${stars}</span>
                            </div>
                            <div class="review-body">${review.review_body}</div>
                            <div class="review-source">Purchased: <b>${review.sku}</b></div>
                            <div class="review-source">Source: ${review.source}</div>
                        </div>
                    `;
                }).join('');
                showAllButton.style.display = 'none'; 
            };
            
            reviewsList.appendChild(showAllButton);
        }
    }
